import {
  APPLICATION_LIST_LOCKED_COLUMN_IDS,
} from '../constants'
import type {
  ApplicationListColumnId,
  ApplicationListLockedColumnId,
} from '../types/listColumns'

export {
  APPLICATION_LIST_COLUMN_OPTIONS,
  APPLICATION_LIST_CUSTOMIZABLE_COLUMN_OPTIONS,
  APPLICATION_LIST_LOCKED_COLUMN_IDS,
  APPLICATION_LIST_DATA_COLUMN_IDS,
} from '../constants'

export type { ApplicationListColumnId, ApplicationListLockedColumnId } from '../types/listColumns'

export function isApplicationListLockedColumn(
  columnId: ApplicationListColumnId,
): columnId is ApplicationListLockedColumnId {
  return APPLICATION_LIST_LOCKED_COLUMN_IDS.includes(
    columnId as ApplicationListLockedColumnId,
  )
}

export function withLockedApplicationListColumns(
  columnIds: ApplicationListColumnId[],
): ApplicationListColumnId[] {
  const withoutLocked = columnIds.filter(
    (columnId) => !isApplicationListLockedColumn(columnId),
  )
  return [...APPLICATION_LIST_LOCKED_COLUMN_IDS, ...withoutLocked]
}
